var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 3.13124e-07 8 6.99382e-07C3.58172 2.03931e-06 -2.99299e-06 3.58172 -2.60673e-06 8C-3.13124e-07 12.4183 3.58172 16 8 16ZM4.3462 8.17149L7.31585 11.1411L7.45727 11.283L8.40722 10.3329L11.9829 6.75723L11.0334 5.80772L7.45743 9.3837L5.2957 7.22198L4.3462 8.17149Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuccess);
export default __webpack_public_path__ + "static/media/ic-success.bfda65e5d2cc2989d6ad93627969580a.svg";
export { ForwardRef as ReactComponent };